import './router/router';
import './sentry/instrument';
import { LicenseManager } from '@uturn/ui-kit';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import '@uturn/ui-kit/fonts.css';
import './i18n';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import App from './App';

dayjs.extend(customParseFormat);
dayjs.extend(timezone);
dayjs.extend(utc);

LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);

function AppRoot() {
	return (
		<StrictMode>
			<App />
		</StrictMode>
	);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
	throw new Error('Root element not found');
}

const root = createRoot(rootElement);
root.render(<AppRoot />);
